/* eslint-disable react/prop-types */
import { forwardRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import cn from "../../../utilities/tailwind-merge";

const ActionsSearchField = forwardRef(
    (
        {
            value,
            onChange,
            placeholder,
            autoFocus = false,
            onFocus,
            onClick,
            className = "",
            inputRef,
            readOnly = false,
        },
        ref,
    ) => (
        <div
            ref={ref}
            className={cn(
                "flex items-center gap-2 rounded-full border border-gray-200 bg-white px-3 py-2.5 focus-within:border-[#5D5DF6]",
                className,
            )}
            onClick={onClick}>
            <SearchOutlined className="shrink-0 text-gray-400" />
            <input
                ref={inputRef}
                type="text"
                autoFocus={autoFocus}
                readOnly={readOnly}
                value={value}
                onChange={onChange}
                onFocus={onFocus}
                placeholder={placeholder}
                className="w-full border-none bg-transparent text-sm leading-5 text-gray-800 outline-none placeholder:text-gray-400"
            />
        </div>
    ),
);

ActionsSearchField.displayName = "ActionsSearchField";

export default ActionsSearchField;
